/*
 * Generic model for tree list
 */

define(["backbone", "jquery"], function (Backbone, $) {
  var TreeListModel = {};

  TreeListModel.node = Backbone.Model.extend({
    defaults: {
      checked: false,
    },
    initialize: function () {
      var nodes = this.get("nodes");
      if (nodes) {
        this.nodes = new TreeListModel.collection(nodes);
        this.unset("nodes");
      }
    },
  });

  TreeListModel.collection = Backbone.Collection.extend({
    model: TreeListModel.node,
  });

  return TreeListModel;
});
